let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gwvAa")).then(() => parcelRequire('fryIH'));